import { StatusOption, BooleanOption } from "../models/code-filters.model";

export const STATUS_OPTIONS: StatusOption[] = [
  { label: 'Active', value: 'Active' },
  { label: 'Inactive', value: 'Inactive' }
];

export const BOOLEAN_OPTIONS: BooleanOption[] = [
  { label: 'Yes', value: true },
  { label: 'No', value: false }
];
